import { render } from "./Workers.vue?vue&type=template&id=547d31c4&scoped=true"
import script from "./Workers.vue?vue&type=script&lang=js"
export * from "./Workers.vue?vue&type=script&lang=js"

import "./Workers.vue?vue&type=style&index=0&id=547d31c4&scoped=true&lang=css"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547d31c4"]])

export default __exports__